export default __webpack_public_path__ + "static/fire-project-9bdab2b3ebfd9637671a6a2b08be0900.jpg";